import script from "./RichTextRenderer.vue?vue&type=script&setup=true&lang=js"
export * from "./RichTextRenderer.vue?vue&type=script&setup=true&lang=js"

import "./RichTextRenderer.vue?vue&type=style&index=0&id=26ff0d2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26ff0d2a"]])

export default __exports__